import { Lottie, LottieAnimationData } from '@remotion/lottie';
import React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { continueRender, delayRender } from 'remotion';

interface LottieComponentProps {
  emojiCode: string | null;
  emoji: string;
  emojiAnimationData: any;
}

export const LottieComponent: React.FC<LottieComponentProps> = React.memo(
  ({ emoji, emojiAnimationData }): any => {
    if (!emojiAnimationData) {
      return emoji;
    }

    return <Lottie animationData={emojiAnimationData} />;
  }
);
